import { render, staticRenderFns } from "./WorkClientAddressTable.vue?vue&type=template&id=13cbe38a&"
import script from "./WorkClientAddressTable.vue?vue&type=script&lang=js&"
export * from "./WorkClientAddressTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports